// Ubicación en el repo: src/lib/prescriptions.js
// Recetas de lentes (OFT) — spec-prototipo.md, tabla `prescriptions`.
// Mismo patrón que exams.js: CRUD + helpers de conversión jsonb↔form-input
// para las tablas Lejos/Cerca (esfera/cilindro/eje) y AVsc/AVcc.
import { supabase } from './supabaseClient';

// Mismas listas que el prototipo (const DIAGNOSTICO_OPTS / USO_OPTS,
// línea ~2303-2304).
export const DIAGNOSTICO_OPTS = ['Miopía', 'Hipermetropía', 'Astigmatismo', 'Presbicia'];
export const USO_OPTS = ['Permanente', 'Semi permanente'];

// { od: {esfera,cilindro,eje}, oi: {...} } → inputs de texto para el form.
export function lensRxToInputs(block) {
  const toInputs = (eye) => ({
    esfera: eye?.esfera ?? '',
    cilindro: eye?.cilindro ?? '',
    eje: eye?.eje ?? '',
  });
  return { od: toInputs(block?.od), oi: toInputs(block?.oi) };
}
export function lensRxToValues(block) {
  const toValues = (eye) => {
    const out = {};
    if (eye?.esfera !== '' && eye?.esfera != null) out.esfera = Number(eye.esfera);
    if (eye?.cilindro !== '' && eye?.cilindro != null) out.cilindro = Number(eye.cilindro);
    if (eye?.eje !== '' && eye?.eje != null) out.eje = String(eye.eje);
    return out;
  };
  return { od: toValues(block?.od), oi: toValues(block?.oi) };
}

// { od: {sc,cc}, oi: {...} } → inputs de texto para el form.
export function avToInputs(block) {
  const toInputs = (eye) => ({ sc: eye?.sc ?? '', cc: eye?.cc ?? '' });
  return { od: toInputs(block?.od), oi: toInputs(block?.oi) };
}
export function avToValues(block) {
  const toValues = (eye) => {
    const out = {};
    if (eye?.sc !== '' && eye?.sc != null) out.sc = String(eye.sc);
    if (eye?.cc !== '' && eye?.cc != null) out.cc = String(eye.cc);
    return out;
  };
  return { od: toValues(block?.od), oi: toValues(block?.oi) };
}

// `patient_branches(branch_id, branches(logo_path))` trae de una vez el
// logo de la sucursal del paciente — se usa al imprimir la receta
// (DECISIONS.md #28 y #39) sin necesitar una consulta aparte.
const PRESCRIPTION_LIST_SELECT =
  'id, patient_id, date, reevaluar, professional_id, ' +
  'patients(nombre, apellido, segundo_nombre, segundo_apellido, rut, birthdate, patient_branches(branch_id, branches(logo_path))), ' +
  'professionals!professional_id(nombre, apellido, role, rut, signature_path)';

// Mismo patrón en dos capas que listExams: RLS ya restringe por
// patient_branch_match, esto solo acota a la sucursal activa elegida en
// el header.
export async function listPrescriptions({ branchId, search } = {}) {
  const { data, error } = await supabase
    .from('prescriptions')
    .select(PRESCRIPTION_LIST_SELECT)
    .is('deleted_at', null)
    .order('date', { ascending: false });
  if (error) throw error;

  let rows = data ?? [];
  if (branchId) {
    rows = rows.filter((r) => (r.patients?.patient_branches ?? []).some((pb) => pb.branch_id === branchId));
  }
  const term = search?.trim().toLowerCase();
  if (term) {
    rows = rows.filter((r) => {
      const p = r.patients;
      if (!p) return false;
      const name = [p.nombre, p.segundo_nombre, p.apellido, p.segundo_apellido].filter(Boolean).join(' ').toLowerCase();
      return name.includes(term) || (p.rut || '').toLowerCase().includes(term);
    });
  }
  return rows;
}

export async function getPrescriptionById(id) {
  const { data, error } = await supabase.from('prescriptions').select('*').eq('id', id).single();
  if (error) throw error;
  return data;
}

export async function createPrescription(values, actorId) {
  const { error } = await supabase.from('prescriptions').insert({
    ...values,
    created_by: actorId,
    updated_by: actorId,
  });
  if (error) throw error;
}

export async function updatePrescription(id, values, actorId) {
  const { error } = await supabase
    .from('prescriptions')
    .update({ ...values, updated_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

export async function softDeletePrescription(id, actorId) {
  const { error } = await supabase
    .from('prescriptions')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}
